var map = {
	"./ais-vision-ai.jpg": "ef45",
	"./rosepetal-analysis.jpg": "ae3c",
	"./rosepetal-dep-aisvision.jpg": "acbd",
	"./rosepetal-dep-aramatics.jpg": "6405",
	"./rosepetal-dep-barinsa.jpg": "0157",
	"./rosepetal-dep-bredenoord.jpg": "1d80f",
	"./rosepetal-dep-calvo.jpg": "3a09",
	"./rosepetal-dep-carnesselectas.jpg": "fd9b",
	"./rosepetal-dep-cerealto-toro.jpg": "f5fb",
	"./rosepetal-dep-cerealto-vb.jpg": "babc",
	"./rosepetal-dep-delafruit.jpg": "192d",
	"./rosepetal-dep-escuris.jpg": "1c30",
	"./rosepetal-dep-flexicap-baxter.jpg": "66c6",
	"./rosepetal-dep-inserma.jpg": "1f14",
	"./rosepetal-dep-montanacolors.jpg": "df11",
	"./rosepetal-dep-scanology.jpg": "bb20",
	"./rosepetal-dev.jpg": "ecd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed7f";